import React from 'react';
import { AlertTriangle } from 'lucide-react';

export default function ConfirmModal({ open, title, message, confirmLabel, confirmColor, onConfirm, onCancel }) {
  if (!open) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(3px)',
      padding: 20,
    }} onClick={onCancel}>
      <div style={{
        background: 'var(--bg-secondary)', border: '1px solid var(--border-primary)',
        borderRadius: 'var(--radius-xl)', padding: 'var(--space-2xl)',
        maxWidth: 440, width: '100%', boxShadow: 'var(--shadow-xl)',
        animation: 'scaleIn 0.2s ease',
      }} onClick={e => e.stopPropagation()}>
        
        <div style={{ textAlign: 'center', marginBottom: 'var(--space-xl)' }}>
          <div style={{
            width: 56, height: 56, borderRadius: '50%',
            background: confirmColor === 'var(--error)' ? 'var(--error-bg)' : 'var(--warning-bg)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto var(--space-md)',
          }}>
            <AlertTriangle size={28} color={confirmColor || 'var(--warning)'} />
          </div>
          <h3 style={{ color: 'var(--text-primary)', fontSize: 17, fontWeight: 700, margin: '0 0 8px' }}>
            {title || 'Confirm Action'}
          </h3>
          <p style={{ color: 'var(--text-secondary)', fontSize: 13, margin: 0, lineHeight: 1.5 }}>
            {message}
          </p>
        </div>

        <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
          <button onClick={onCancel} style={{
            padding: '10px 24px', borderRadius: 10,
            border: '1px solid var(--border-primary)',
            background: 'transparent', color: 'var(--text-secondary)',
            cursor: 'pointer', fontSize: 13, fontWeight: 600,
          }}>
            Cancel
          </button>
          <button onClick={onConfirm} style={{
            padding: '10px 24px', borderRadius: 10, border: 'none',
            background: confirmColor || 'var(--error)',
            color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 600,
          }}>
            {confirmLabel || 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );
}
